import React from "react";
import {getAttribute} from "../../FormEdit/FormEditReducerHelpers";
import {InputGroup, RadiusInput} from "../Base/BaseStyles";

export function InputNumberEditTab({component_key, attributes, dispatch}) {
  const input_number_question = getAttribute("question", attributes);
  return (
    <InputGroup className="input-group">
      <RadiusInput
        type="text"
        className="form-control"
        aria-label=""
        placeholder="Enter your question"
        value={input_number_question}
        onChange={(event) =>
          dispatch({
            type: "input_number_question_change",
            question: event.target.value,
            key: component_key,
          })
        }
      />
    </InputGroup>
  );
}

export default InputNumberEditTab;
